export const AGENDA_GET = 'AGENDA_GET';